// extracted by mini-css-extract-plugin
export default {"header__wrapper":"Header_header__wrapper__xFFnv","logo":"Header_logo__njp2l"};